export default __webpack_public_path__ + "static/media/fablab2.2cd4c37d.jpg";